/*
* 考勤系统
* */

// 学生请假
const StudentLeave = () => import( /* webpackChunkName: "attendance" */ '@/pages/attendance/views/studentLeave/StudentLeave.vue')
const StudentLeaveSubApplication = () => import( /* webpackChunkName: "attendance" */ '@/pages/attendance/views/studentLeave/StudentLeaveSubApplication.vue')
const StudentLeaveSubApproval = () => import( /* webpackChunkName: "attendance" */ '@/pages/attendance/views/studentLeave/StudentLeaveSubApproval.vue')
const StudentLeaveSubRecord = () => import( /* webpackChunkName: "attendance" */ '@/pages/attendance/views/studentLeave/StudentLeaveSubRecord.vue')
const StudentLeaveSubSubSitute = () => import( /* webpackChunkName: "attendance" */ '@/pages/attendance/views/studentLeave/StudentLeaveSubSubSitute.vue')
const StudentLeaveSubCreate = () => import( /* webpackChunkName: "attendance" */ '@/pages/attendance/views/studentLeave/StudentLeaveSubCreate.vue')
const StudentLeaveSubRecordDetail = () => import( /* webpackChunkName: "attendance" */ '@/pages/attendance/views/studentLeave/StudentLeaveSubRecordDetail.vue')
const StudentLeaveApprovalDetails = () => import( /* webpackChunkName: "attendance" */ '@/pages/attendance/views/studentLeave/ApprovalDetails.vue')
// 请假统计
const StudentLeaveStat = () => import( /* webpackChunkName: "attendance" */ '@/pages/attendance/views/studentLeave/Stat.vue')

// 教师考勤
const TeacherAttendance = () => import( /* webpackChunkName: "attendance" */ '@/pages/attendance/views/teacherAttendance/TeacherAttendance.vue')

// 教师请假
const TeacherLeave = () => import( /* webpackChunkName: "attendance" */ '@/pages/attendance/views/teacherLeave/TeacherLeave.vue')
const TeacherLeaveMyLeave = () => import( /* webpackChunkName: "attendance" */ '@/pages/attendance/views/teacherLeave/TeacherLeaveMyLeave.vue')
const TeacherLeaveApproval = () => import( /* webpackChunkName: "attendance" */ '@/pages/attendance/views/teacherLeave/TeacherLeaveApproval.vue')
const TeacherLeaveDetails = () => import( /* webpackChunkName: "attendance" */ '@/pages/attendance/views/teacherLeave/details.vue')
const TeacherLeaveCreate = () => import( /* webpackChunkName: "attendance" */ '@/pages/attendance/views/teacherLeave/create.vue')
const TeacherLeaveRecord = () => import( /* webpackChunkName: "attendance" */ '@/pages/attendance/views/teacherLeave/Record.vue')

// 学生考勤
const StudentAttendance = () => import( /* webpackChunkName: "attendance" */ '@/pages/attendance/views/studentAttendance/StudentAttendance.vue')
const AttendanceAdmin = () => import( /* webpackChunkName: "attendance" */ '@/pages/attendance/views/studentAttendance/AttendanceAdmin.vue')
const AttendanceStatQuery = () => import( /* webpackChunkName: "attendance" */ '@/pages/attendance/views/studentAttendance/AttendanceStatQuery.vue')
const AttendanceTeach = () => import( /* webpackChunkName: "attendance" */ '@/pages/attendance/views/studentAttendance/AttendanceTeach.vue')
const AttsLesson = () => import( /* webpackChunkName: "attendance" */ '@/pages/attendance/views/studentAttendance/AttsLesson.vue')
const TakeAttendance = () => import( /* webpackChunkName: "attendance" */ '@/pages/attendance/views/studentAttendance/TakeAttendance.vue')
const MyAttendance = () => import( /* webpackChunkName: "attendance" */ '@/pages/attendance/views/studentAttendance/MyAttendance.vue')

// 审批流发起选择更多抄送人时组件
const coper = () => import( /* webpackChunkName: "basic" */ '@/components/workFlow/coper')
const coperForm = () => import( /* webpackChunkName: "basic" */ '@/components/workFlow/coperForm')
const coperUser = () => import( /* webpackChunkName: "basic" */ '@/components/workFlow/coperUser')




const attendace = [
  // attendance router
  {
    path: 'StudentAttendance',
    name: 'StudentAttendance',
    component: StudentAttendance,
    children: [
      {
        path: 'AttendanceAdmin',
        name: 'AttendanceAdmin',
        component: AttendanceAdmin
      },
      {
        path: 'AttendanceStatQuery',
        name: 'AttendanceStatQuery',
        component: AttendanceStatQuery
      },
      {
        path: 'AttendanceTeach',
        name: 'AttendanceTeach',
        component: AttendanceTeach
      },
      {
        path: 'AttsLesson',
        name: 'AttsLesson',
        component: AttsLesson
      },
      {
        path: 'TakeAttendance',
        name: 'TakeAttendance',
        component: TakeAttendance
      },
      {
        path: 'MyAttendance',
        name: 'MyAttendance',
        component: MyAttendance
      }
    ],
  },
  {
    path: 'StudentLeave',
    name: 'StudentLeave',
    component: StudentLeave,
    children: [
      {
        path: 'Application',
        name: 'Application',
        component: StudentLeaveSubApplication
      },
      {
        path: 'ApprovalDetails',
        name: 'ApprovalDetails',
        component: StudentLeaveApprovalDetails
      },
      {
        path: 'Approval',
        name: 'Approval',
        component: StudentLeaveSubApproval
      },
      {
        path: 'Record',
        name: 'Record',
        component: StudentLeaveSubRecord
      },
      {
        path: 'SubSitute',
        name: 'SubSitute',
        component: StudentLeaveSubSubSitute
      },
      {
        path: 'Create',
        name: 'Create',
        component: StudentLeaveSubCreate
      },
      {
        path: 'edit',
        name: 'edit',
        component: StudentLeaveSubCreate
      },
      {
        path: 'Detail',
        name: 'Detail',
        component: StudentLeaveSubRecordDetail
      },
      {
        path: 'Stat',
        name: 'Stat',
        component: StudentLeaveStat
      }
    ],
  },
  {
    path: 'TeacherAttendance',
    name: 'TeacherAttendance',
    component: TeacherAttendance
  },
  {
    path: 'TeacherLeave',
    name: 'TeacherLeave',
    component: TeacherLeave,
    children: [
      {
        // 我的请假
        path: 'myLeave',
        name: 'myLeave',
        component: TeacherLeaveMyLeave
      },
      {
        // 请假审批
        path: 'leaveApproval',
        name: 'leaveApproval',
        component: TeacherLeaveApproval
      },
      {
        path: 'TeacherLeaveDetails',
        name: 'TeacherLeaveDetails',
        component: TeacherLeaveDetails
      },
      {
        path: 'TeacherLeaveCreate',
        name: 'TeacherLeaveCreate',
        component: TeacherLeaveCreate,
      },
      {
        // 请假记录
        path: 'recordLeave',
        name: 'recordLeave',
        component: TeacherLeaveRecord
      },
      // 选择更多抄送人
      {
        path: 'coper',
        name: 'coper',
        component: coper
      },
      {
        path: 'coperForm/:id/:type',
        name: 'coperForm',
        component: coperForm
      },
      {
        path: 'coperUser/:id/:type',
        name: 'coperUser',
        component: coperUser
      },
    ],
  },
]
export default attendace
